import { render, staticRenderFns } from "./FileDownload.vue?vue&type=template&id=bfa60066&scoped=true"
import script from "./FileDownload.vue?vue&type=script&lang=js"
export * from "./FileDownload.vue?vue&type=script&lang=js"
import style0 from "./FileDownload.vue?vue&type=style&index=0&id=bfa60066&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa60066",
  null
  
)

export default component.exports